import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { AnchoredList } from "@/components/AnchoredList";

export const CodigoRealInput = ({ value, placeholder, testId, onType, onPick }) => {
  const [sugerencias, setSugerencias] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const timer = useRef(null);
  const wrap = useRef(null);

  const buscar = (q) => {
    if (timer.current) clearTimeout(timer.current);
    if (!q || q.trim().length < 2) { setSugerencias([]); setAbierto(false); return; }
    timer.current = setTimeout(async () => {
      setCargando(true);
      try {
        const { data } = await api.get("/repuestos/autocompletar", { params: { q: q.trim() } });
        setSugerencias(data || []); setAbierto(true);
      } catch { setSugerencias([]); }
      finally { setCargando(false); }
    }, 280);
  };

  useEffect(() => () => timer.current && clearTimeout(timer.current), []);

  useEffect(() => {
    const onDoc = (e) => {
      if (e.target.closest && e.target.closest("[data-anchored-list]")) return;
      if (wrap.current && !wrap.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={wrap} className="relative">
      <Input data-testid={testId} value={value || ""} placeholder={placeholder}
        autoComplete="off" className="h-6 text-xs font-mono w-40"
        onChange={(e) => { onType(e.target.value); buscar(e.target.value); }}
        onFocus={() => { if (sugerencias.length) setAbierto(true); }} />
      <AnchoredList anchorRef={wrap} open={abierto && (sugerencias.length > 0 || cargando)} minWidth={288} className="text-xs">
        <div data-testid={`${testId}-sugerencias`}>
          {cargando && sugerencias.length === 0 && <div className="px-2 py-1.5 text-muted-foreground">Buscando…</div>}
          {sugerencias.map((r) => (
            <button key={r.id} type="button" data-testid={`${testId}-opt-${r.id}`}
              className="block w-full text-left px-2 py-1.5 hover:bg-secondary"
              onClick={() => { onPick(r); setAbierto(false); }}>
              <span className="font-mono font-semibold">{r.codigo_parte}</span>
              <span className="text-muted-foreground"> — {r.nombre}</span>
            </button>
          ))}
        </div>
      </AnchoredList>
    </div>
  );
};
